//package imports
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory,useParams,Switch} from "react-router-dom";



//component imports
import Sidemenu from "../sidebar/Sidemenu";
import AdminDashboard from "./AdminDashboard";
import DataManagement from "./DataManagement";
import EnquiresList from "./EnquiresList";
import PriceConfiguration from "./PriceConfiguration";
import ShareManagement from "./ShareManagement";
import StoreManagement from "./StoreManagement";
import UserManagement from "./UserManagement";
import OrderRequest from "./OrderRequest";
import PrivateRoute from "../../router/PrivateRoute";
import Dropdown from 'react-bootstrap/Dropdown';
import PublicRoute from "../../router/PublicRoute";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import { getData,removeData } from "../../utils/AsyncStorage";
import PageNotFound from  "../errorHandler/PageNotFound"
import UserDetailedView from "../adminPanel/userDetailedView/UserDetailedView"
import AddStoresForms from "./AddStoresForm";
import StoreDetails from "./StoreDetails";
import MasterData from "./MasterData";
import AdminCreateProfile from "./CreateProfile";
import SeoData from "./SeoData";
import ShareReports from "./ShareReports";




const AdminPanel = (props) => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const [sidebarCollapse, setSidebarCollapse] = useState(false)
  const [showLogout, setShowLogout] = useState(false);
  const closeLogoutModal = () => setShowLogout(false)
  const { role,first_name } = JSON.parse(getData("userInfo") || 0);



  useEffect(() => {
    // Simulating an unauthorized scenario
    const isUnauthorized = role !== 2; // Replace with your actual authorization logic
    if (isUnauthorized) {
      // Navigate to the unauthorized page
      history.replace('/unauthorized');
    }
  }, [history]);



  const handleLogoutModal = (event) => {
    event.preventDefault();
    setShowLogout(true)
  }

  //function to handle logout 
  const handleItemLogout = (event) => {
    event.preventDefault();
    removeData("accessToken");
    removeData("userInfo")
    removeData("refresh_token")
    history.push("/login")
  }

  return (
    <div className="container-fluid p-0">
      <div className="col-md-12 d-flex ">

        <Sidemenu
          collapse={sidebarCollapse}
          path={path}
        />

        <div className={sidebarCollapse ? "d-flex flex-column  col-md-11 sub-height" : " d-flex flex-column sub-height  col-md-10"}>
          <div className="col-md-12 ">
            <nav className="navbar navbar-light navStyle  p-0 ">
              <div className="mx-2" onClick={() => setSidebarCollapse(!sidebarCollapse)} >
                <i className="bi bi-list fs-2 text-white"></i>
              </div>
              <ul className="nav justify-content-center align-items-center ms-auto">
                
                <li className="nav-item mx-2">
                  <h1 className="text-white fs-5 m-0">{first_name}</h1>
                </li>
                <li className="nav-item mx-2">
                  <Dropdown >
                    <Dropdown.Toggle id="dropdown-basic" variant="transparent" style={{ border: 0 ,color:"white"}}>
                      <i className="bi bi-person-circle fs-2 "></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="" onClick={handleLogoutModal} >Logout</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </ul>

            </nav>
          </div>
{

     <div style={{flex:1,overflowY:"auto"}}>
      <Switch>
            <PrivateRoute
              restricted={true}
              component={AdminDashboard}
              path={`${path}/adminDashboard`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={DataManagement}
              path={`${path}/dataManagement`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={PriceConfiguration}
              path={`${path}/priceConfiguration`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={ShareManagement}
              path={`${path}/shareManagement`}
              exact
            />
             <PrivateRoute
              restricted={true}
              component={ShareReports}
              path={`${path}/shareReports`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={StoreManagement}
              path={`${path}/storeManagement`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={UserManagement}
              path={`${path}/userManagement`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={OrderRequest}
              path={`${path}/orderRequest`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={EnquiresList}
              path={`${path}/enquiresList`}
              exact
            />            
            <PrivateRoute
            restricted={true}
            component={UserDetailedView}
            path={`${path}/userManagement/userDetailedView`}
            exact
          />
          <PrivateRoute
            restricted={true}
            component={AddStoresForms}
            path={`${path}/storeManagement/addStoreForm`}
            exact
          />
          <PrivateRoute
            restricted={true}
            component={StoreDetails}
            path={`${path}/storeManagement/storeDetails`}
            exact
          />
          <PrivateRoute
            restricted={true}
            component={MasterData}
            path={`${path}/masterData`}
            exact
          />
          <PrivateRoute
            restricted={true}
            component={SeoData}
            path={`${path}/seoData`}
            exact
          />
          <PrivateRoute
            restricted={true}
            component={AdminCreateProfile}
            path={`${path}/createProfile`}
            exact
          />
          
          <PublicRoute component={PageNotFound} path="*" exact />
          </Switch>
          </div>
}

          <CustomModal
            close={closeLogoutModal}
            open={showLogout}
            Action={handleItemLogout}
            modalContent={"Are you sure you want to log out?"}
          />
          
        </div>
      </div>
    </div>
  )
}

export default AdminPanel